import styled from 'styled-components';
import { makeStyles, createStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      marginTop: '50px',
    },
  })
);

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: rgba(29, 28, 28, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 150px;
`;
